<template>
  <div class="bg-neutral-300 rounded" />
</template>
